import * as contentful from 'contentful';
export const client= contentful.createClient({
    space:'70ltaxnpyf43',
    accessToken:'cuy-Tzgjl00TddFhJtj6X_u3NK3DnwFYQdFmSXlTv9g'
})
